import { OutlinedInput } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import { useCallback, useRef, useState } from "react";
import { ChromePicker } from "react-color";
import { IProductParams } from "../../../../model";
import { appLogger } from "../../../../utils";

import useClickOutside from "./useClickOutside";

const BrandingColor = (props: any) => {
  appLogger.info({
    infoObj: {
      method: "BrandingColor",
      component: "add-product",
      fileName: "BrandingColor.tsx",
      prpos: props,
    },
  });
  const { chatbotAppearance, setChatbotAppearance, field, bgColor } = props;
  const [ismainTitleClrPalletOpen, setmainTitleClrPalletOpen] = useState(false);

  const mainTitileClrPopover = useRef<any>(null);
  const mainTitleclrpalleteclose = useCallback(
    () => setmainTitleClrPalletOpen(false),
    []
  );

  useClickOutside(mainTitileClrPopover, mainTitleclrpalleteclose);

  const handleColorChange = (event: any) => {
    const color = event;
    if (chatbotAppearance) {
      const temp: any | undefined = { ...chatbotAppearance };
      if (temp) {
        if (field == "Primary Color") {
          temp["cuvo-chatbot-header-bg-color"] = color;
          temp["cuvo-chatbot-user-bg-color"] = color;
          temp["cuvo-chatbot-bot-icon-bg-color"] = color;
          temp["cuvo-chatbot-primary-button-text-color"] = color;
          temp["cuvo-chatbot-primary-button-bg-color"] = `${color}50`;
          temp["cuvo-chatbot-secondary-button-text-color"] = color;
          const bwColor = handleTextColorChange(color);
          temp["cuvo-chatbot-header-text-color"] = bwColor;
          temp["cuvo-chatbot-user-text-color"] = bwColor;
          setChatbotAppearance(temp);
        } else if (field == "Action Color") {
          temp["cuvo-chatbot-bot-action-text-color"] = color;
          temp["cuvo-chatbot-bot-action-bg-color"] = `${color}50`;
          // temp["cuvo-chatbot-input-text-color"] = handleTextColorChange(color);
          temp["cuvo-chatbot-send-icon-bg-color"] = color;
          setChatbotAppearance(temp);
        } else if (field == "Bot Msg Box Color") {
          temp["cuvo-chatbot-bot-bg-color"] = color;
          temp["cuvo-chatbot-secondary-button-bg-color"] = color;
          const bwColor = handleTextColorChange(color);
          temp["cuvo-chatbot-bot-text-color"] = bwColor;
          setChatbotAppearance(temp);
        }
      }
    }
  };

  // const padZero = (str: string, len?: any) => {
  //   len = len || 2;
  //   var zeros = new Array(len).join('0');
  //   return (zeros + str).slice(-len);
  // }
  const handleTextColorChange = (hex: string, bw?: boolean) => {
    bw = bw || true;
    if (hex.indexOf("#") === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    // if (hex.length !== 6) {
    //   throw new Error("Invalid HEX color.");
    // }
    const r = parseInt(hex.slice(0, 2), 16),
      g = parseInt(hex.slice(2, 4), 16),
      b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
    }
    // // invert color components
    // const red = (255 - r).toString(16);
    // const green = (255 - g).toString(16);
    // const blue = (255 - b).toString(16);
    // // pad each with zeros and return
    // return "#" + padZero(red) + padZero(green) + padZero(blue);
  };

  return (
    <>
      <Grid>
        <div className="mainAgentpickerColorDiv">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={1}>
              <Grid xs={2}>
                <div
                  className="swatch"
                  style={{ backgroundColor: bgColor }}
                  onClick={() => setmainTitleClrPalletOpen(true)}
                />
              </Grid>
              <Grid xs={10}>
                <div>
                  <FormControl className="custom-select" fullWidth>
                    <InputLabel>{field}</InputLabel>
                    <OutlinedInput
                      id={`${field}`}
                      type="text"
                      value={bgColor}
                      label="Background Color"
                      onChange={(event) => {
                        handleColorChange(event.target.value);
                      }}
                      onFocus={(event) => {
                        setmainTitleClrPalletOpen(true);
                      }}
                    />
                  </FormControl>
                </div>
              </Grid>
            </Grid>
          </Box>
          {ismainTitleClrPalletOpen && (
            <div className="popoverpick" ref={mainTitileClrPopover}>
              {/* <CloseIcon
                    className="cursor-pointer picker-close"
                    onClick={() => mainTitleclrpalleteclose()}
                  /> */}
              <div
                className="cursor-pointer picker-close"
                onClick={() => mainTitleclrpalleteclose()}
              >
                Close
              </div>
              <ChromePicker
                color={bgColor}
                onChange={(color) => {
                  handleColorChange(color.hex);
                }}
              />
            </div>
          )}
        </div>
      </Grid>
    </>
  );
};

export default BrandingColor;
